import { useMutation, useQueryClient } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { QUERY_KEY_BANK_CHARACTER } from "@/domains/bank/hooks/useBankCharacterQuery";
import { QUERY_KEY_BANK_TRANSACTIONS } from "@/domains/bank/hooks/useBankTransactionsQuery";

export function useChangeTariffMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tariffId: number) => {
      const response = await BankMpProvider.changeTariff({ tariffId });

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.error?.message);
      }

      return response.data;
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY_BANK_CHARACTER] }),
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY_BANK_TRANSACTIONS] }),
      ]);
    },
  });
}
